import { render, staticRenderFns } from "./TableNotifications.vue?vue&type=template&id=eb9ea4d8&scoped=true"
import script from "./TableNotifications.js?vue&type=script&lang=js&external"
export * from "./TableNotifications.js?vue&type=script&lang=js&external"
import style0 from "./TableNotifications.vue?vue&type=style&index=0&id=eb9ea4d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb9ea4d8",
  null
  
)

export default component.exports